<template>
  <div class="dashboard-container">
    <el-container>
      <el-header class="header">
        <div class="header-content">
          <h2>墅梯智选管理后台</h2>
          <el-button type="text" @click="logout" style="color: #fff;">退出登录</el-button>
        </div>
      </el-header>
      <el-container>
        <el-aside width="200px" class="sidebar">
          <el-menu
            :default-active="$route.path"
            router
            background-color="#304156"
            text-color="#bfcbd9"
            active-text-color="#409EFF"
          >
            <el-menu-item index="/dashboard/showroom">
              <i class="el-icon-office-building"></i>
              <span>展厅管理</span>
            </el-menu-item>
            <el-menu-item index="/dashboard/article">
              <i class="el-icon-document"></i>
              <span>文章管理</span>
            </el-menu-item>
            <el-menu-item index="/dashboard/brand">
              <i class="el-icon-star-on"></i>
              <span>品牌管理</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-main class="main-content">
          <router-view/>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  created() {
    if (this.$route.path === '/dashboard' || this.$route.path === '/dashboard/') {
      this.$router.replace('/dashboard/showroom');
    }
  },
  methods: {
    logout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('token');
        this.$router.push('/login');
        this.$message.success('已退出登录');
      });
    }
  }
}
</script>

<style scoped>
.dashboard-container {
  height: 100vh;
}

.header {
  background: linear-gradient(90deg, #4f5bd5, #5f2c82);
  color: #fff;
  display: flex;
  align-items: center;
  padding: 0;
}

.header-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.header-content h2 {
  margin: 0;
  font-size: 20px;
}

.sidebar {
  background-color: #304156;
}

.main-content {
  background-color: #f5f5f5;
  padding: 20px;
}

.el-menu {
  border-right: none;
}
</style>